import { type ItemMappingExport } from "../schemas"
import { itemType, type ItemType } from "./schemas"

/**
 * create
 */
export const create: ItemMappingExport<ItemType>["create"] = (order, languages, id) => ({
  type: itemType,
  order,
  props: {
    titleLevel: 1,
    projects: [],
    category: null,
    orientation: null,
    omit: id,
  },
  translations: A.map(languages, ({ id: languageId }) => ({
    languageId,
    props: { title: "", secondary: "" },
  })),
  files: [],
})
